document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.hkg-drawer');
  const toggle = document.querySelector('.hkg-menu-toggle');
  const close = document.querySelector('.hkg-menu-close');
  const scrim = document.querySelector('.hkg-scrim');
  if (!drawer || !toggle || !close || !scrim) return;
  const setOpen = (open) => {
    drawer.classList.toggle('is-open', open);
    scrim.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    drawer.toggleAttribute('inert', !open);
    toggle.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
  };
  toggle.addEventListener('click', () => setOpen(true));
  close.addEventListener('click', () => setOpen(false));
  scrim.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (event) => event.key === 'Escape' && setOpen(false));
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hilbert-language]').forEach((button) => {
    button.addEventListener('click', () => {
      const form = button.closest('form[action*="/localization"]');
      if (!form || button.getAttribute('aria-current') === 'true') return;

      const values = {
        form_type: 'localization',
        utf8: '✓',
        _method: 'put',
        return_to: `${window.location.pathname}${window.location.search}`,
        language_code: button.value,
      };

      Object.entries(values).forEach(([name, value]) => {
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
        input.setAttribute('value', value);
      });

      HTMLFormElement.prototype.submit.call(form);
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cookie-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (window.Shopify?.customerPrivacy?.showPreferences) {
        window.Shopify.customerPrivacy.showPreferences();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.details-content .text-block').forEach((description) => {
    const paragraphs = Array.from(description.querySelectorAll(':scope > p'));
    const legacyDeliveryHeading = paragraphs.find((paragraph) => {
      const text = paragraph.textContent.trim().toLowerCase();
      return text === 'delivery' || text === 'levering';
    });

    if (!legacyDeliveryHeading) return;

    const legacyDeliveryText = legacyDeliveryHeading.nextElementSibling;
    const legacyShippingText = legacyDeliveryText?.nextElementSibling;
    legacyDeliveryHeading.remove();
    legacyDeliveryText?.remove();
    legacyShippingText?.remove();
  });
});
